import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/outline';
import { ProductStyle } from '../../domain/product/product_style';

export interface Props {
  data: ProductStyle & { is_selected: boolean };
  onSelect: (styleProductId: string) => void;
}

export function HouseStyleCard(props: Props) {
  const { image_url, name, is_selected } = props?.data;
  const { onSelect } = props;

  return (
    <div
      className="inline-block cursor-pointer rounded border border-gray-300 p-4 shadow-lg active:shadow-none"
      onClick={() => onSelect(props.data.product_id)}
    >
      <img className="m-auto rounded w-full" src={image_url} />
      <div className="mt-3 flex items-center justify-center">
        <CheckCircleIcon
          className={`mr-1 h-6 w-6 text-green-800 ${
            is_selected ? 'inline-block' : 'hidden'
          }`}
        />
        <label className="inline-block text-center">{name}</label>
      </div>
    </div>
  );
}
